export default __webpack_public_path__ + "static/media/virtual_services_photo_fr.63085d09.png";